export const useGlobalStore = () => useState('global', () => ({
    availableLocales: [
        { code: 'en', iso: 'en-US', name: 'English', flag: 'us' },
        { code: 'it', iso: 'it-IT', name: 'Italiano', flag: 'it' }
    ],
    busy: false,
    messageModal: {
        visible: false,
        type: '',
        title: '',
        message: ''
    }
}));